import React, { useRef } from 'react';
import { sanitizeHtml } from '../../utils/sanitizeHtml';
import Modal from '../shared/Modal';

const DeleteModal = ({ open, onClose, onConfirm, message, messages, isMultiple = false, subject = 'message' }) => {
    const cancelRef = useRef(null);
    const confirmRef = useRef(null);

    if (!open) return null;

    // Fonction pour extraire le texte brut du HTML
    const stripHtml = (html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = sanitizeHtml(html || '');
        return tempDiv.textContent || tempDiv.innerText || '';
    };

    // Modal actions
    const modalActions = (
        <>
            <button
                ref={cancelRef}
                onClick={onClose}
                className="flex-1 bg-gray-300 dark:bg-gray-700 text-gray-800 dark:text-gray-200 font-bold py-2 px-4 rounded hover:bg-gray-400 dark:hover:bg-gray-600"
            >
                Annuler
            </button>
            <button
                ref={confirmRef}
                onClick={onConfirm}
                className="flex-1 bg-red-600 dark:bg-red-500 text-white font-bold py-2 px-4 rounded hover:bg-red-700 dark:hover:bg-red-600"
            >
                {isMultiple ? `Supprimer (${messages?.length || 0})` : 'Supprimer'}
            </button>
        </>
    );

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Confirmer la suppression"
            actions={modalActions}
            initialFocusRef={confirmRef}
        >
            {/* Contenu */}
            <p className="mb-4 text-black dark:text-gray-300">
                {isMultiple ? (
                    `Êtes-vous sûr de vouloir supprimer ces ${messages?.length || 0} messages ?`
                ) : (() => {
                    const s = String(subject || 'message').toLowerCase();
                    // If it's an organisation, use the feminine demonstrative
                    if (s.includes('organis')) return `Êtes-vous sûr de vouloir supprimer cette ${subject} ?`;
                    // default to masculine demonstrative
                    return `Êtes-vous sûr de vouloir supprimer ce ${subject} ?`;
                })()}
            </p>

            {/* Détails du/des message(s) */}
            {isMultiple ? (
                <div className="mb-6 max-h-64 overflow-y-auto">
                    <p className="text-sm font-medium text-black dark:text-white mb-3">
                        Messages à supprimer :
                    </p>
                    <div className="space-y-2">
                        {messages?.slice(0, 5).map((msg, index) => (
                            <div key={msg._id} className="p-2 bg-gray-50 dark:bg-gray-700 rounded border dark:border-gray-600">
                                <p className="text-xs font-medium text-black dark:text-white truncate">
                                    {msg.title}
                                </p>
                                <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 mt-1">
                                    <span className="px-1 py-0.5 bg-gray-200 dark:bg-gray-600 rounded text-xs">
                                        {msg.type}
                                    </span>
                                    <span>•</span>
                                    <span>{msg.role}</span>
                                </div>
                            </div>
                        ))}
                        {messages && messages.length > 5 && (
                            <div className="text-xs text-gray-500 dark:text-gray-400 text-center py-2">
                                ... et {messages.length - 5} autres messages
                            </div>
                        )}
                    </div>
                </div>
            ) : message && (
                <div className="mb-6 p-3 bg-gray-50 dark:bg-gray-700 rounded border dark:border-gray-600">
                    <p className="text-sm font-medium text-black dark:text-white mb-2">
                        {message.title}
                    </p>
                    <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                        <span className="px-2 py-0.5 bg-gray-200 dark:bg-gray-600 rounded">
                            {message.type}
                        </span>
                        <span>•</span>
                        <span>{message.role}</span>
                    </div>
                    {message.content && (
                        <p className="text-xs text-gray-600 dark:text-gray-400 mt-2 line-clamp-2 whitespace-pre-wrap break-words">
                            {stripHtml(message.content)}
                        </p>
                    )}
                </div>
            )}

            {/* Avertissement */}
            <div className="mb-6 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded">
                <p className="text-sm text-yellow-800 dark:text-yellow-300">
                    ⚠️ Cette action est irréversible.
                </p>
            </div>
        </Modal>
    );
};

export default DeleteModal;